// Normalises arbitrary rendered text (article/comment/tweet bodies, which may
// contain HTML tags, HTML entities like `&#x27;` / `&amp;` / `&nbsp;`, URLs and
// emoji) into something that reads cleanly through speechSynthesis.
//
// Used both at the call sites that build ReadableItem.texts and, as a safety
// net, inside useReadAloud right before an utterance is spoken.

const URL_RE = /https?:\/\/\S+|www\.\S+/gi;

// emoji + pictographic glyphs (incl. skin-tone modifiers), regional-indicator
// flag letters, and the zero-width joiners / variation selectors left behind
const EMOJI_RE = /[\p{Extended_Pictographic}\p{Emoji_Modifier}]/gu;
const FLAG_RE = /[\u{1F1E6}-\u{1F1FF}]/gu;
const JOINER_RE = /[\u{FE00}-\u{FE0F}\u{200D}]/gu;

// "Symbol, other" (☑ ★ ➜ ™ ° …), zero-width / format controls, and C0/C1
// control chars — none of which speak meaningfully. Currency ($ € £) and normal
// punctuation are deliberately kept.
const SYMBOL_RE = /[\p{So}\p{Cf}\p{Cc}]/gu;

function decodeHtmlEntities(input: string): string {
  if (typeof document === "undefined" || !/&[#a-z0-9]+;/i.test(input)) return input;
  // A detached <textarea> decodes every named + numeric entity without
  // executing scripts or fetching anything (its content is plain text).
  const el = document.createElement("textarea");
  el.innerHTML = input;
  return el.value;
}

export function cleanTextForSpeech(text: string): string {
  if (!text) return "";

  let out = text.replace(/<[^>]*>/g, " "); // drop HTML tags
  out = decodeHtmlEntities(out); // &#x27; -> '  &amp; -> &  &nbsp; ->
  out = out.replace(/<[^>]*>/g, " "); // in case entities revealed more markup

  out = out
    .replace(URL_RE, "")
    .replace(EMOJI_RE, "")
    .replace(FLAG_RE, "")
    .replace(JOINER_RE, "")
    .replace(SYMBOL_RE, "");

  // collapse whitespace (JS \s covers the   that &nbsp; decodes to)
  return out.replace(/\s{2,}/g, " ").trim();
}
